import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { Loader2, Trash2, Download, Mail } from "lucide-react";
import { toast } from "sonner";

export function NewsletterSubscribers() {
  const [subs, setSubs] = useState(null);

  const load = () => api.newsletterSubscribers().then(setSubs).catch(() => setSubs([]));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Ta bort prenumeranten?")) return;
    await api.deleteSubscriber(id);
    toast.success("Borttagen");
    load();
  };

  const exportCsv = () => {
    const rows = [["email", "source", "created_at"], ...subs.map((s) => [s.email, s.source || "", s.created_at])];
    const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
    const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8;" }));
    const a = document.createElement("a");
    a.href = url; a.download = `nyhetsbrev-prenumeranter-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click(); URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="newsletter-admin">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <h2 className="font-display text-3xl font-black uppercase text-white">Nyhetsbrev</h2>
        <div className="flex items-center gap-4">
          <span className="font-mono text-sm text-white/50" data-testid="subscriber-count">{subs ? `${subs.length} prenumeranter` : "Laddar…"}</span>
          {subs && subs.length > 0 && (
            <button onClick={exportCsv} data-testid="export-csv" className="inline-flex items-center gap-2 rounded-lg bg-amber-500 px-4 py-2 text-sm font-bold text-black hover:bg-amber-400">
              <Download className="w-4 h-4" /> Exportera CSV
            </button>
          )}
        </div>
      </div>

      {subs === null && <div className="grid place-items-center py-16"><Loader2 className="w-8 h-8 animate-spin text-amber-500" /></div>}
      {subs && subs.length === 0 && <p className="text-white/40 font-mono text-sm">Inga prenumeranter ännu.</p>}

      <div className="space-y-2">
        {subs && subs.map((s) => (
          <div key={s.id} data-testid={`subscriber-${s.id}`} className="flex items-center gap-3 rounded-lg border border-white/8 bg-[#14161A] px-4 py-3">
            <Mail className="w-4 h-4 text-white/30 shrink-0" />
            <span className="flex-1 min-w-0 truncate text-white">{s.email}</span>
            <span className="font-mono text-[10px] uppercase tracking-widest text-white/35">{s.source}</span>
            <span className="font-mono text-[10px] text-white/30">{new Date(s.created_at).toLocaleDateString("sv-SE")}</span>
            <button onClick={() => del(s.id)} className="p-2 text-white/40 hover:text-red-500"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
